var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0556 26.5H14.25C13.1454 26.5 12.25 25.6046 12.25 24.5V14.5C12.25 13.3954 13.1454 12.5 14.25 12.5H20.75H27.25C28.3546 12.5 29.25 13.3954 29.25 14.5V18.5667",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18.25,
    width: 7.5,
    height: 12.5,
    rx: 1.25,
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 28.75C11.3358 28.75 11 29.0858 11 29.5C11 29.9142 11.3358 30.25 11.75 30.25V28.75ZM11.75 30.25H23.75V28.75H11.75V30.25Z",
    fill: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClients);
export default __webpack_public_path__ + "static/media/btn_clients.ce4a22663290d52dbc4e38069b39f5e4.svg";
export { ForwardRef as ReactComponent };